import { Declaration } from 'store/declarations/declaration';
import { sortMirroredDeclarations } from '../sortMirroredDeclarations';

// The BE returns every declaration of the split, so the user lands on the first one (B1 number 1).
export const getLandingDeclarationId = (declarations: Declaration[]): string | undefined => {
    const [firstDeclaration] = sortMirroredDeclarations(declarations);

    return firstDeclaration?.id;
};
